import { Data } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import FileDescriptor from '../Models/FileDescriptor';

export interface IImagesApiClient {

    getUploadImageUrl(): string;

    getImageUrl(fileDescriptorId: number): AxiosPromise<string>;

    // Client only properties / methods
}

@injectable()
export default class ImagesApiClient extends Data.ApiClientBase implements IImagesApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/images`);
    }

    public getUploadImageUrl(): string {
        return `${this.apiPath}`;
    }

    public getImageUrl(fileDescriptorId: number): AxiosPromise<string> {
        return this.axios.get(`${this.apiPath}/uri?fileDescriptorId=${fileDescriptorId}`);
    }

    // Client only properties / methods
}